import { IsActiveMatchOptions, Router } from '@angular/router';

const EXACT_ACTIVE: IsActiveMatchOptions = {
  paths: 'exact',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};

const PREFIX_ACTIVE: IsActiveMatchOptions = {
  paths: 'subset',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};

/**
 * Rutas hijas / aliases que deben marcar el ítem canónico del panel.
 * Clave = route del NavItem; valor = URLs que también lo activan.
 */
const NAV_ROUTE_ALIASES: Readonly<Record<string, readonly string[]>> = {
  '/finance/income-expenses': [
    '/finance/income',
    '/finance/expenses',
    '/finance/categories',
  ],
};

function normalizeNavRoute(route: string): string {
  const trimmed = route.trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

/** True si la URL actual corresponde al route del ítem (exact, prefix o alias). */
export function isNavRouteActive(
  router: Router,
  route: string | undefined | null
): boolean {
  if (!route?.trim()) {
    return false;
  }
  const url = normalizeNavRoute(route);
  if (
    router.isActive(url, EXACT_ACTIVE) ||
    router.isActive(url, PREFIX_ACTIVE)
  ) {
    return true;
  }
  const aliases = NAV_ROUTE_ALIASES[url];
  if (!aliases?.length) {
    return false;
  }
  return aliases.some(
    (alias) =>
      router.isActive(alias, EXACT_ACTIVE) ||
      router.isActive(alias, PREFIX_ACTIVE)
  );
}
